import {toDate, toNumber} from "@/lib/utils";

export const o = {
  str: (v: any): string | undefined => {
    if (typeof v === "undefined" || v === null || v === "") {
      return undefined;
    }
    return v;
  },
  bool: (v: any): boolean | undefined => {
    if (typeof v === "undefined" || v === null) {
      return undefined;
    }
    if (typeof v === "boolean") {
      return v;
    }
    let s = String(v).toLowerCase();
    return s === "true" || s === "1" || s === "yes";
  },
  num: (v: any): number | undefined => {
    if (typeof v === "undefined" || v === null) {
      return undefined;
    }
    if (typeof v === "number") {
      return v === 0 ? undefined : v;
    }
    let n = parseFloat(String(v).replace(/[^0-9.-]/g, ""));
    console.log("num", isNaN(n) ? undefined :  n);
    return isNaN(n) ? undefined :  n;
  },
  obj: <T>(v: T): T | undefined => {
    if (typeof v === "undefined" || v === null) {
      return undefined;
    }
    let empty = Object.values(v).every(v => v === null || v === "" || v === undefined);
    return empty ? undefined : v;
  }
};

export const d = {
  str: (v: any): string => {
    if (typeof v === "undefined" || v === null) {
      return "";
    }
    return String(v);
  },
  dateStr: (v: any): string => {
    if (typeof v === "undefined" || v === null || v === "") {
      return "";
    }
    if (typeof v === "string") {
      if (v.indexOf("T") !== -1) {
        return v.split("T")[0];
      }
      // return new Date(v).toISOString().split("T")[0];
      return toDate(v).toISOString().split("T")[0];
    }
    return "";
  },
  date: (v: any): Date => {
    if (typeof v === "undefined" || v === null) {
      return new Date();
    }
    if (typeof v === "string") {
      return new Date(v);
    }
    return new Date();
  },
  boolNum: (v: any): boolean => {
    if (typeof v === "undefined" || v === null) {
      return "" as unknown as boolean;
    }
    return (v ? "1" : "0") as unknown as boolean;
  },
  boolYesNo: (v: any): string => {
    if (typeof v === "undefined" || v === null) {
      return "";
    }
    return v ? "Yes" : "No";
  },
  num: (v: any): number => {
    if (typeof v === "undefined" || v === null) {
      return '' as unknown as number;
    }
    if (typeof v === "number") {
      return v;
    }
    let n = toNumber(v);
    return (!n ? "" : n) as unknown as number;
  }
}
